import { SxProps, Theme } from '@mui/material';

export const styles: Record<'wrapper', SxProps<Theme>> = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: (theme) => theme.spacing(1),
  },
};
